module.exports = __webpack_public_path__ + "img/intro.6f893d7f.svg";